import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {InsparkOverlayHlsVideoComponent} from './inspark-overlay-hls-video/inspark-overlay-hls-video.component';



@NgModule({
  declarations: [InsparkOverlayHlsVideoComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule

  ],
  exports: [InsparkOverlayHlsVideoComponent]
})
export class InsparkOverlayHlsVideoModule { }
